import { FunctionalComponent, h } from '@stencil/core';
import { Icon as IconConfiguration } from '../../../../configuration/icons';

export interface IconProps {
  icon: IconConfiguration;
}

export const Icon: FunctionalComponent<IconProps> = ({ icon }) => {
  return <rudy-icon icon={icon} />;
};
